import nameReducer from "./nameReducer"
import { combineReducers } from "redux"
const rootReducer = combineReducers({
    nameReducer
})
export default rootReducer;